import React, { useState } from 'react';
import { arrayOf, object, shape, string, number, bool } from 'prop-types';
import { FilterContext } from 'js/containers/filter-context';
import Pagination from 'react-paginate';
import Filter from 'components/filter/component';
import Result from './result';

const LessonPlanResults = ( props ) => {

    const handleSort = ( e ) => {

        const element = e.target;
        const optionIndex = element.getAttribute( 'data-option' );
        const selectedOption = props.config.sortOptions[ optionIndex ];
        const sortType = selectedOption.query.sortBy;
        const currentPage = props.config.pagination.activePage;
        const allResults = state.results[ sortType ][ state.currentAgeLevel.value ];

        setState( { ...state,
            currentPage,
            currentResults: allResults[ currentPage ],
            selectedSort: sortType,
            totalPages: allResults.length,
        } );

    };

    const sortByGrade = ( levelMap, results ) => {

        const sortedResult = { all: pagedResult( results ) };

        levelMap.map( ( level ) => {

            sortedResult[ level.name ] = pagedResult( results.filter( ( result ) => {

                return level.grades.includes( result.attributes.level );

            } ) );

        } );

        return sortedResult;

    };

    const sortAlphabetically = ( levelMap, results ) => {

        const allSortedResult = results.sort( ( a, b ) => {

            return ( a.attributes.title < b.attributes.title ) ? -1 : ( a.attributes.title > b.attributes.title ) ? 1 : 0;

        } );

        return sortByGrade( levelMap, allSortedResult );

    };

    const sortFederalOption = ( levelMap, results ) => {

        const allFedResult = results.filter( ( result ) => {

            return result.attributes.video && result.attributes.exhibit;

        } );

        const allNonFedResults = results.filter( ( result ) => {

            return !( result.attributes.video && result.attributes.exhibit );

        } );

        const allSortedResult = [ ...allFedResult, ...allNonFedResults ];

        return sortByGrade( levelMap, allSortedResult );

    };

    const onFilterChange = ( selectedOption ) => {

        const currentPage = props.config.pagination.activePage;
        const allResults = state.results[ state.selectedSort ][ selectedOption.value ];

        setState( { ...state,
            currentAgeLevel: selectedOption,
            currentPage,
            currentResults: allResults[ currentPage ],
            totalPages: allResults.length,
        } );

    };

    const handlePagination = ( options ) => {

        const currentPage = options.selected;
        const currentResults = state.results[ state.selectedSort ][ state.currentAgeLevel.value ][ currentPage ];

        setState( { ...state,
            currentPage,
            currentResults,
        } );

    };

    const pagedResult = ( result ) => {

        const pagedResult = [];
        const resultsPerPage = props.config.query.pageSize;

        for ( let i = 0, j = result.length; i < j; i += resultsPerPage ) {

            pagedResult.push( result.slice( i, i + resultsPerPage ) );

        }

        return pagedResult;

    };

    const filterResultsByFacet = ( levelMap, results ) => {

        const finalResult = {

            alpha: sortAlphabetically( levelMap, results ),
            fedFirst: sortFederalOption( levelMap, results ),

        };

        return finalResult;

    };

    const renderSortBy = () => {

        const selectedSort = state.selectedSort;

        return (
            <div className="lesson-plan-sort">
                <p className="sort-label">Sort by:</p>
                <ul>
                    { props.config.sortOptions.map( ( option, index ) => {

                        if ( selectedSort === option.query.sortBy ) {

                            return (
                                <li className="selected" key={ option.name }>
                                    <span>{ option.name }</span>
                                </li>
                            );

                        }

                        return (
                            <li key={ option.name }>
                                <button
                                    type="button"
                                    data-option={ index }
                                    onClick={ handleSort }
                                >
                                    { option.name }
                                </button>
                            </li>
                        );

                    } ) }
                </ul>
            </div>
        );

    };

    const renderFilters = () => {

        return props.config.filters.map( ( filter ) => {

            const revisedFacets = filter.facets.filter( ( option ) => {

                return state.results.alpha[ option.query.level ].length !== 0;

            } );

            filter.facets = revisedFacets;

            return (

                <Filter
                    key={ filter.name }
                    labelId="filter-title"
                    filter={ filter }
                    onChange={ onFilterChange }
                    value={ state.currentAgeLevel }
                />

            );

        } );

    };

    const renderResults = ( ) => {

        return state.currentResults.map( ( result ) => {

            return <Result key={ result.id } { ...result } />;

        } );

    };

    const selectedSort = props.config.query.sortBy;
    const results = filterResultsByFacet( props.config.levelMap, props.config.results );
    const currentPage = props.config.pagination.activePage;
    const resultsPerPage = props.config.query.pageSize;
    const currentAgeLevel = {
        label: props.config.filters[ 0 ].name,
        value: 'all',
    };
    const [ state, setState ] = useState( {
        results,
        currentPage,
        selectedSort,
        currentAgeLevel,
        currentResults: results[ selectedSort ][ currentAgeLevel.value ][ currentPage ],
        totalPages: Math.ceil( props.config.results.length / resultsPerPage ),
    } );

    return (
        <>
            <form className="lesson-plan-filters">
                <div className="filters-container">
                    <p className="filter-title" id="filter-title">Filter by:</p>
                    <div className="filters">
                        { renderFilters() }
                    </div>
                </div>
                { renderSortBy() }
            </form>
            <div className="results">
                { renderResults() }
            </div>
            { state.totalPages > 1
              && (
                  <Pagination
                      disableInitialCallback
                      nextLabel={ <span aria-label="Next page"></span> }
                      previousLabel={ <span aria-label="Previous page"></span> }
                      pageCount={ state.totalPages }
                      marginPagesDisplayed={ 1 }
                      forcePage={ state.currentPage }
                      onPageChange={ handlePagination }
                      containerClassName="lesson-plan-pagination"
                  />
              )}

        </>
    );

};

const withSubscribe = ( props ) => {

    const [ filterState, setFilterState ] = useState( { currentFilterOptions: {} } );

    return (
        <FilterContext.Provider value={ { filterState, setFilterState } }>

            <LessonPlanResults
                config={ props.config.attributes.data }
            />

        </FilterContext.Provider>

    );

};

LessonPlanResults.propTypes = {
    config: shape( {
        attributes: shape( {
            data: shape( {
                query: shape( {
                    pageSize: number.isRequired,
                } ),
                pagination: shape( {
                    activePage: number.isRequired,
                    totalPages: number.isRequired,
                } ),
                filters: arrayOf( shape( {
                    name: string.isRequired,
                    facets: arrayOf( shape( {
                        name: string.isRequired,
                        query: object.isRequired,
                    } ) ),
                } ) ),
                sortOptions: arrayOf( shape( {
                    name: string,
                    query: object,
                } ) ).isRequired,
                results: arrayOf( shape( {
                    attributes: shape( {
                        level: string.isRequired,
                        title: string.isRequired,
                        url: string.isRequired,
                        video: bool.isRequired,
                        exhibit: bool.isRequired,
                        excerpt: string,
                        authors: arrayOf( shape( {
                            name: string.isRequired,
                        } ) ),
                    } ),
                } ) ).isRequired,
            } ),
        } ),
    } ).isRequired,
};

export default withSubscribe;
